import "./footer.styles.scss"
import Icon from "../icon/icon.component"
import { Link } from "react-router-dom"
import { useState } from "react"
import emailjs from "emailjs-com"

function Footer() {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [formTouched, setFormTouched] = useState(false)

  function formChange(event, settingFunction) {
    setFormTouched(true)
    settingFunction(event.target.value)
  }

  function formSubmit(e) {
    e.preventDefault()

    emailjs
      .sendForm(
        "service_datgy1d",
        "template_wqurpvg",
        e.target,
        "user_u7wcCiTKkvBYquTURwEl4"
      )
      .then(
        (result) => {
          console.log(result.text)
          alert("Message sent")
        },
        (error) => {
          console.log(error.text)
          alert("Sorry, an error occured")
        }
      )

    setEmail("")
    setMessage("")
    setName("")
  }

  const nameValid = !formTouched || name.trim().length > 0
  const messageValid = !formTouched || message.trim().length > 0
  const emailValid = !formTouched || email.trim().includes("@")

  return (
    <div className="footer-wrapper" id="contact">
      <div className="footer-top-image"> </div>
      <div className="footer-content">
        <h4 className="form-text">Interested in being a part of our raise?</h4>
        <div className="footer-forms-and-info">
          <div className="form">
            <form onSubmit={formSubmit}>
              <input
                className={nameValid ? "" : "invalid"}
                type="text"
                name="name"
                placeholder="Name"
                value={name}
                onChange={(e) => {
                  formChange(e, setName)
                }}
              />
              <input
                className={emailValid ? "" : "invalid"}
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(e) => {
                  formChange(e, setEmail)
                }}
              />
              <textarea
                className={messageValid ? "" : "invalid"}
                name="message"
                placeholder="Message"
                rows={7}
                value={message}
                onChange={(e) => {
                  formChange(e, setMessage)
                }}
              ></textarea>
              <button type="submit">Submit</button>
            </form>
          </div>
          <div className="contact">
            <Icon name="phone" />
            <h4>Contact us</h4>
            <div>team@educationequation.co.uk</div>
            <div>amir@educationequation.co.uk</div>
            {/* <div>+44 7827224343</div> */}
            <div>
              Education Equation
              <br />
              WeWork
              <br />
              3 Waterhouse Square
              <br />
              London
              <br />
              EC1N 2SW
            </div>
          </div>
        </div>
      </div>
      <div className="footer-links">
        <div className="links">
          <div>
            <Icon name="logo" />
          </div>
          <Link
            onClick={() => {
              document
                .getElementById("contact")
                .scrollIntoView({ behavior: "smooth" })
            }}
          >
            Contact us
          </Link>
          <a href="https://platform.educationequation.co.uk">Log in</a>
          {/* <a href="/PrivacyPolicy.pdf">Privacy policy</a>
          <a href="/CookiePolicy.pdf">Cookie policy</a> */}
          {/* <Link>Safeguarding policy</Link> */}
          {/* <Link></Link> */}
        </div>
        <div className="info">
          <div>© 2022 Education Equation</div>
        </div>
      </div>
    </div>
  )
}

export default Footer
